var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"image-viewer"}},[_c('div',{attrs:{"id":"image-viewer-close"},on:{"click":_vm.close}},[_c('img',{attrs:{"id":"iv-close","src":require("../../../assets/close_fill.svg"),"alt":""}})]),_c('div',{attrs:{"id":"image-viewer-inner"}},[_c('img',{attrs:{"src":_vm.path,"alt":"image"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }